import {Component, inject, OnInit} from '@angular/core';
import { ZendeskService } from './../services/zendesk.service';
import { BrandService } from '../services/brand.service';

@Component({
    selector: 'app-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.scss'],
    standalone: false
})
export class ClientComponent implements OnInit {

  private readonly _brandService = inject(BrandService);

  constructor(
    private zendesk: ZendeskService,
  ) { }

  ngOnInit() {
    this.zendesk.hide();
  }
}
